// The rules for linking an assessment to an impact assessment — Survey.project
// on the BE (the UI calls a project an "impact assessment" here).
//
//  * OPTIONAL: linked, the assessment is one of the project's Evidence and
//    its single-choice questions can ask about the project's segments;
//    unlinked, it belongs to no project.
//  * EDITABLE until the first completed response, then LOCKED: answers to a
//    segment-linked question are the choices of THAT project's segment, so
//    moving the assessment afterwards would leave them pointing elsewhere.
//
// The BE is the authority on the lock. It is read from `project_locked` when
// the payload carries it, else derived from a completed-response count.

// A project reference as the BE may send it — an id, or { id, name } — as the
// string id the pickers use ("" for none).
export const projectIdOf = (raw) => {
    if (raw == null || raw === "") return "";
    if (typeof raw === "object") return raw.id != null ? String(raw.id) : "";
    return String(raw);
};

export const isProjectLinkLocked = ({ projectLocked, completedResponses } = {}) => {
    if (typeof projectLocked === "boolean") return projectLocked;
    return Number(completedResponses) > 0;
};
